import {
  ADD_MESSAGE,
  CLEAR_MESSAGE,
  NotificationActionTypes,
  NotificationState,
} from './types';

const initialState: NotificationState = {
  messages: [],
};

export function notificationReducer(
  state = initialState,
  action: NotificationActionTypes,
): NotificationState {
  switch (action.type) {
    case ADD_MESSAGE: {
      // ignore duplicate messagesu
      if (state.messages?.find((msg) => msg.id === action.message.id)) {
        return state;
      }
      return {
        ...state,
        messages: [...state.messages, action.message],
      };
    }
    case CLEAR_MESSAGE:
      return {
        ...state,
        messages: state.messages.filter((message) => message.id !== action.id),
      };
    default:
      return state;
  }
}
